// extracted by mini-css-extract-plugin
export default {"root":"ReservedPane-module__root___3urcn","closeButtonWrapper":"ReservedPane-module__closeButtonWrapper___2jg1z"};